export const examples: Array<{ path: string, name: string }> = [
	{ path: 'basic-init', name: 'Basic Initialization' },
	{ path: 'templates', name: 'Configs & Templates' },
	{ path: 'custom-form', name: 'Custom Task Form' },
	{ path: 'custom-edit-view', name: 'Custom Editor View' },
	{ path: 'inline-editors', name: 'Inline Editors' },
	{ path: 'auto-scheduling', name: 'Auto Scheduling' },
	{ path: 'redux-toolkit', name: 'Redux Toolkit Integration' },
	{ path: 'resource-panel', name: 'Resource Histogram' },
	{ path: 'export-data', name: 'Export' },
];